import styled from 'styled-components';

export const Bar = styled.div`  
  width: 100%;
  height: 3px;
  margin-top: 1rem;
  background: linear-gradient(to right, ${(props) => props.theme.colors.red}, ${(props) => props.theme.colors.lightBlue},${(props) => props.theme.colors.red},${(props) => props.theme.colors.red});
  border-radius: 10px;
  filter: blur(2px);

  animation: barAnimation 10s linear infinite;

  @keyframes barAnimation{
    0%{
      background-position: 0 0;
    }
    100%{
      background-position: 5000px 0;
    }
  }
`;

export const Label = styled.div`
  color: white;
  font-weight: 600;
  text-transform: uppercase;
`;

const Wrapper = styled.div`
  width: 100%;
`;

export default Wrapper;